import React, { useState, useEffect } from 'react';
import { getWinnerInfo, getRunnerOddsByMarketId, getMatchPrediction } from "../../../../service/backend-api-service"
import { Button } from 'react-bootstrap';
const AiAgentTips = (props) => {
    const [prediction, setPrediction] = useState(null);

    function getRecommendedByName(name) {
        if (prediction && prediction.recommended_stakes && prediction.recommended_stakes.proportional) {
            return prediction.recommended_stakes.proportional
                .filter(u => u.runner === name)
                .map(u => u.runner + "(" + u.stake + ")")
                .join(" , ");
        }
        return "";
    }

    function getRecommended(recommendationType) {
        if (prediction && prediction.summary) {
            const name = prediction.summary[recommendationType]
            return getRecommendedByName(name);
        }
        return "";
    }

    function capitalizeFirstWord(str) {
        if (!str) return "";
        const words = str.split(" ");
        words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
        return words.join(" ");
    }


    useEffect(() => {
        const fetchData = async () => {
            let matchId = props.matchId;
            const prediction = await getMatchPrediction(matchId, props.date)
            setPrediction(prediction);

        }
        fetchData();
    }, [props.matchId])

    let contentBody = null
    const data = prediction && prediction.predictions ? prediction.predictions : [];
    if (data.length === 0) {
        contentBody = <p>No data available</p>;
    } else {
        // Get table headers from object keys

        const headers = ["name", "Market%", "RBWM%", "Ensemble%"];
        contentBody = (
            <table className="border-collapse border border-gray-400 font-normal w-full text-left">
                <thead>
                    <tr>
                        {headers.map((header) => (
                            <th key={header} className="border border-gray-400 font-normal px-2 py-1">
                                {capitalizeFirstWord(header === 'Ensemble%' ? 'Ai Agent%' : header)}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, i) => (
                        <tr key={i}>
                            {headers.map((header) => (
                                <td key={header} style={{ fontWeight: 100 }} className="border border-gray-400 font-normal px-2 py-1">
                                    {row[header]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }

    return (
        <>
            <div style={{color:"green"}}>
                <b>Gold:</b> {getRecommended('gold')} {' '} <b>Silver:</b> {getRecommended('silver')} {' '}
                <b>Bronze:</b> {getRecommended('bronze')}<br />
                <b>Race Type: </b>{prediction ? prediction.type : ""}
            </div>
            {contentBody}
        </>
    )
}

export default AiAgentTips;